import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';

import { AuthService } from '@usheru-hff/authentication/domain';
import { NavigationService } from '@usheru-hff/sdk/navigation';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';
@Component({
  selector: 'ush-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  styleUrls: ['./user-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class UserDropdownComponent implements OnInit, OnDestroy {
  /**
   * Entries in the dropdown with the routes related to the user.
   */

  userMenuItems: MenuItem[];

  /**
   * Name of the actual user if is logged.
   */
  username: string;

  /**
   * Obserbable to get the current user logged data.
   */
  private userSubscription: Subscription;

  userIcon = faUser;

  constructor(
    private router: Router,
    private translationService: TranslationsService,
    private authService: AuthService,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.fillUserMenuItems();
    this.userSubscription = this.authService.$userStatus.subscribe(user => {
      this.username = user ? user.username : undefined;
      this.fillUserMenuItems();
    });
  }

  /**
   * Sets the info and actions of the user menu ({@link userMenuItems}).
   */
  private fillUserMenuItems(): void {
    this.userMenuItems = [];

    if (this.username) {
      this.userMenuItems.push({
        label: this.username,
        icon: 'pi pi-user'
      });
      this.userMenuItems.push({
        label: $localize`:@@public.header.link.logout:Logout`,
        icon: 'pi pi-fw pi-sign-out',
        command: (/*event*/) => {
          this.authService.logout();
        }
      });
      this.userMenuItems.push({
        label: $localize`:@@public.header.link.myFilms:My films`,
        icon: 'pi pi-video',
        command: (/*event*/) => {
          this.goToFilms();
        }
      });
    } else {
      this.userMenuItems.push({
        label: $localize`:@@public.header.link.login:Login`,
        icon: 'pi pi-fw pi-sign-in',
        routerLink: ['/auth/login'],
        command: (/*event*/) => {
          this.saveCurrentLinkToComeBack();
        }
      });

      this.userMenuItems.push({
        label: $localize`:@@public.header.link.signUp:Sign up`,
        icon: 'pi pi-fw pi-user-plus',
        routerLink: ['/auth/register'],
        command: (/*event*/) => {
          this.saveCurrentLinkToComeBack();
        }
      });
    }
  }

  /**
   * Trigger logout of the {@link AuthService}
   */
  logout(): void {
    this.authService.logout();
  }

  /**
   * @docsNotRequired
   */
  goToFilms(): void {
    this.router.navigate(['/my-films']);
  }

  /**
   * Used in some entries of the {@link userMenuItems}.
   */
  saveCurrentLinkToComeBack() {
    this.navigationService.setBeforeAuthUrl();
  }

  /**
   * //TODO barbeitoalex - this is necessary?
   */
  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }
}
